import request from "@/utils/request";
import store from "@/store";

export function getProgramProductGroupList(params) {
  return request({
    url: "/api/ecommerce/program_product_groups/",
    method: "get",
    params
  });
}

export function getProgramProductGroupByID(id) {
  return request({
    url: "/api/ecommerce/program_product_groups/"+id+"/",
    method: "get"
  });
}

export function getProgramProductList(params) {
  return request({
    url: "/api/ecommerce/program_products/",
    method: "get",
    params
  });
}

export function getProgramProductByID(id) {
  return request({
    url: "/api/ecommerce/program_products/"+id+"/",
    method: "get",
  });
}

export function getDiscountList(params) {
  return request({
    url: "/api/user/ecommerce/program_orders/get_discount_plans/",
    method: "get",
    params,
    headers: { Authorization: "JWT " + store.state.user.accessToken },
  });
}

export function getOrderList(page) {
  return request({
    url: "/api/user/ecommerce/program_orders/?page=" + page,
    method: "get",
    headers: { Authorization: "JWT " + store.state.user.accessToken },
  });
}

export function getOrderByID(id) {
  return request({
    url: "/api/user/ecommerce/program_orders/"+id+"/",
    method: "get",
    headers: { Authorization: "JWT " + store.state.user.accessToken },
  });
}

export function confirmOrder(data) {
  return request({
    url: "/api/user/ecommerce/program_orders/",
    method: "post",
    data,
    headers: { Authorization: "JWT " + store.state.user.accessToken },
  });
}

export function deleteOrder(id) {
  return request({
    url: "/api/user/ecommerce/program_orders/"+id+"/",
    method: "delete",
    headers: { Authorization: "JWT " + store.state.user.accessToken },
  });
}

export function sendQuestion(data) {
  return request({
    url: "/api/user/ecommerce/program_order_replies/",
    method: "post",
    data,
    headers: { Authorization: "JWT " + store.state.user.accessToken },
  });
}

export function addStudent(data) {
  return request({
    url: "api/ecommerce/program_apply_targets/",
    method: "post",
    data
  });
}
